import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const fetchFactures = createAsyncThunk("factures/fetchAll", async ({ page = 1, pageSize = 10 } = {}, { rejectWithValue }) => {
  try { const r = await api.get('/Facture', { params: { page, pageSize } }); return r.data; } // PagedResult
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const createFacture = createAsyncThunk("factures/create", async (data, { rejectWithValue }) => {
  try {
    await api.post('/Facture', data);
    const list = await api.get('/Facture', { params: { page: 1, pageSize: 10 } });
    return list.data; // PagedResult
  } catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const deleteFacture = createAsyncThunk("factures/delete", async (id, { rejectWithValue }) => {
  try { await api.delete(`/Facture/${id}`); return id; }
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const downloadFacturePdf = createAsyncThunk("factures/downloadPdf", async (id, { rejectWithValue }) => {
  try {
    const response = await api.get(`/Facture/${id}/pdf`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `facture-${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return id;
  } catch (e) { return rejectWithValue(e.message); }
});

const slice = createSlice({
  name: "factures",
  initialState: {
    items: [],
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetSuccess: (state) => { state.success = false; },
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFactures.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchFactures.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(fetchFactures.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(createFacture.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(createFacture.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.currentPage = 1;
        state.success = true;
      })
      .addCase(createFacture.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(deleteFacture.fulfilled, (state, action) => {
        state.items = state.items.filter(i => i.id !== action.payload);
        state.totalCount = Math.max(0, state.totalCount - 1);
        state.success = true;
      })
      .addCase(deleteFacture.rejected, (state, action) => { state.error = action.payload; });
    builder
      .addCase(downloadFacturePdf.rejected, (state, action) => { state.error = action.payload; });
  },
});

export const { resetSuccess, clearError } = slice.actions;
export default slice.reducer;
